import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { IAttributeDetectorForm } from 'hooks/attribute-range-detectors/useAttributeDetectorForm';
import { DeviceManager } from 'core/react/share/devices/DeviceManager';

interface IDevicesSelectProps {
  isDisabled?: boolean;
}

export const DevicesSelect: FC<IDevicesSelectProps> = ({ isDisabled }) => {
  const { control } = useFormContext<IAttributeDetectorForm>();

  return (
    <Controller
      control={control}
      name="uris"
      render={({ value, onChange }) => (
        <DeviceManager uris={value} setUris={onChange} isDisabled={isDisabled} isEditMode />
      )}
    />
  );
};
